/*
 * Custom PDP wishlist heart - writes to Swym Wishlist Plus list so that
 * the header heart counter, floating launcher, and /pages/wishlist all
 * stay in sync. Replaces Swym's auto-injected "Add to wishlist" button
 * on PDP (disable that in Swym admin → Storefront UI → Product Page).
 *
 * Why JS instead of Swym's data-attribute auto-bind:
 *   - swat.addToWishList() callback is reliable for write ops
 *   - swat.fetch() callback is unreliable (silent failure) - we keep
 *     the heart visual state optimistic on click and don't rely on
 *     fetch for initial state. If page reloads while item is in list,
 *     Swym's evtLayer fires 'swym:wishlist-loaded' that we listen to
 *     for correct hydration.
 */
(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  function getProductConfig(node) {
    return {
      epi: parseInt(node.dataset.variantId, 10) || -1, // empty product id => -1 for legacy products
      empi: parseInt(node.dataset.productId, 10),       // master product id
      du: node.dataset.productUrl,
      iu: node.dataset.productImage,
      pr: parseFloat(node.dataset.productPrice) / 100 || 0,
      dt: node.dataset.productTitle
    };
  }

  function setPressed(node, pressed) {
    node.setAttribute('aria-pressed', pressed ? 'true' : 'false');
    var label = pressed ? node.dataset.labelRemove : node.dataset.labelAdd;
    if (!label) return;
    var labelNode = node.querySelector('.custom-pdp-heart__label');
    if (labelNode) labelNode.textContent = label;
    node.setAttribute('aria-label', label);
  }

  function pulse(node) {
    node.classList.add('custom-pdp-heart--pulse');
    setTimeout(function () { node.classList.remove('custom-pdp-heart--pulse'); }, 300);
  }

  function readSwymWishlist() {
    try {
      var raw = localStorage.getItem('swym-products');
      if (!raw) return [];
      var data = JSON.parse(raw);
      return ((data && data.all) || []).filter(function (it) { return it && it.et === 4; });
    } catch (e) { return []; }
  }

  function isInList(config) {
    return readSwymWishlist().some(function (item) {
      return item && (item.empi === config.empi || item.epi === config.epi);
    });
  }

  function bind(node, swat) {
    if (node.dataset.swymBound === '1') return;
    node.dataset.swymBound = '1';

    var config = getProductConfig(node);

    // Hydrate initial state from Swym's localStorage cache
    try {
      if (isInList(config)) setPressed(node, true);
    } catch (e) { /* graceful: leave outline */ }

    var pendingClass = node.classList.contains('custom-card-heart')
      ? 'custom-card-heart--pending'
      : 'custom-pdp-heart--pending';

    node.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (node.dataset.pending === '1') return;
      node.dataset.pending = '1';
      node.classList.add(pendingClass);

      var pressed = node.getAttribute('aria-pressed') === 'true';

      var op = pressed ? 'removeFromWishList' : 'addToWishList';
      var callback = function (response) {
        node.dataset.pending = '';
        node.classList.remove(pendingClass);
        // Optimistic - flip state regardless of response timing
        setPressed(node, !pressed);
        pulse(node);
      };

      try {
        if (typeof swat[op] === 'function') {
          swat[op](config, callback);
          // Safety net: if callback never fires, flip state after 1s
          setTimeout(function () {
            if (node.dataset.pending === '1') callback();
          }, 1000);
        } else {
          callback();
        }
      } catch (e) {
        callback();
      }
    });
  }

  function init() {
    var nodes = document.querySelectorAll('[data-pdp-wishlist-heart]');
    if (!nodes.length) return;

    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function (swat) {
      nodes.forEach(function (n) { bind(n, swat); });

      // Re-sync state from Swym localStorage cache on cross-surface changes
      function resync() {
        nodes.forEach(function (n) {
          var config = getProductConfig(n);
          setPressed(n, isInList(config));
        });
      }
      if (swat.evtLayer && typeof swat.evtLayer.addEventListener === 'function') {
        swat.evtLayer.addEventListener('swym:wishlist-loaded', resync);
        swat.evtLayer.addEventListener('swym:wishlist-update', resync);
      }
      window.addEventListener('storage', function (e) {
        if (e.key === 'swym-products') resync();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
